/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  Col,
  Form,
  Spin,
  DatePicker,
  Input,
  Typography,
  Button,
  notification,
} from 'antd';
import Select from 'components/Select';
import Table from 'components/Table';
import percentFormatter from 'utils/percentFormatter';
import { formatReceivedValues } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import { getEmpleadosConDatosOpFilteredPaginated, getEmpleadosOptimized } from 'api/estructuraOrganizacional/empleados';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getPuestos } from 'api/catalogos/puestos';
import { getTiposDeEmpleados, getAreas } from 'api/catalogos';
import { getEstadosDeEmpleados } from 'api/estructuraOrganizacional/estadosDeEmpleados';
import { getVacacionesEmpleadosPeriodos } from 'api/nominas/vacaciones/vacacionesEmpleadosPeriodos';
import { getVacacionesEmpleadosDiasDisfrutados } from 'api/nominas/vacaciones/vacacionesEmpleadosDiasDisfrutados';
import { getAdministracionDePlazas, getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import descargarConsultaVacaciones from 'api/nominas/vacaciones/descargarConsultaVacaciones';
import FormSubmitControls from 'components/FormSubmitControls';
import moment from 'moment';
import { onError } from 'utils/handlers';
import namePDF from 'components/PDF/namePDF';
import { getPlazas, getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { SearchOutlined } from '@ant-design/icons';
import CustomSearch from 'components/customSearch';

const { Text } = Typography;

const ConsultaVacaciones = () => {
  const [empleados, setEmpleados] = useState([]);
  const [datosOperacionales, setDatosOperacionales] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [areas, setAreas] = useState([]);
  const [tiposDeEmpleados, setTiposDeEmpleados] = useState([]);
  const [estadosDelEmpleado, setEstadosDelEmpleado] = useState([]);
  const [vacacionesEmpleadosPeriodos, setVacacionesEmpleadosPeriodos] = useState([]);
  const [vacacionesEmpleadosDisfrutados, setVacacionesEmpleadosDisfrutados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allowPrint, setAllowPrint] = useState(false);
  const [plazas, setPlazas] = useState([]);
  const [adminPlazas, setAdminPlazas] = useState([]);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [open, setVisible] = useState(false);
  const [data, setData] = useState([]);
  const [baseURIPagination, setBaseURIPagination] = useState();
  const [selectedEmpleado, setSelectedEmpleado] = useState();
  const [form] = Form.useForm();

  let baseURI = 'catalogos/dato-operacional-del-empleado-paginado/?empleados_filter=';

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const calcularAntiguedad = (fechaRegistro) => {
    const fechaDiferencia = Date.now() - fechaRegistro;
    const fechaNueva = new Date(fechaDiferencia);
    const fechaAnual = (fechaNueva.getUTCFullYear() - 1970);
    const fechaMes = (fechaNueva.getUTCMonth());
    if ((Math.sign(fechaAnual) === -1) || (Number.isNaN(fechaAnual))) {
      return 0;
    }
    return `${fechaAnual} ${(fechaAnual === 1 ? 'año' : 'años')} ${fechaMes} ${(fechaMes === 1 ? 'mes' : 'meses')}`;
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      const [
        _vacacionesPeriodos,
        _empleados,
        _adminPlazas,
        _plazas,
        _datosOperacionales,
        _puestos,
        _areas,
        _tiposDeEmpleados,
        _tipos_de_nominas_empleados,
        _estadosDelEmpleado,
      ] = await Promise.all([
        getVacacionesEmpleadosPeriodos(),
        getEmpleadosOptimized(),
        getAdministracionDePlazasvistaOptimized(),
        getPlazasvistaOptimized(),
        getDatoOperacionalesDeEmpleados(),
        getPuestos(),
        getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
        getTiposDeEmpleados(),
        getTiposDeNominasEmpleados(),
        getEstadosDeEmpleados(),
      ]);
      const formattedURS = normalizeData(_areas);
      // eslint-disable-next-line max-len
      const _empleadosFiltered = _empleados.filter((e) => _vacacionesPeriodos.some((x) => x.empleado === e.id));
      if (mounted) {
        setEmpleados(_empleadosFiltered);
        setAdminPlazas(_adminPlazas);
        setPlazas(_plazas);
        setDatosOperacionales(_datosOperacionales);
        setPuestos(_puestos);
        setAreas(formattedURS);
        setTiposDeEmpleados(_tiposDeEmpleados);
        setTiposDeNominaEmpleado(_tipos_de_nominas_empleados);
        setEstadosDelEmpleado(_estadosDelEmpleado);
      }
      setLoading(false);
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onPrint = async () => {
    try {
      setLoading(true);
      const pdf = await descargarConsultaVacaciones(selectedEmpleado?.id);
      const _empleado = empleados?.find((empleado) => empleado?.id === selectedEmpleado?.id);
      const name = namePDF('Vacaciones', _empleado);
      if (pdf) {
        const blob = new Blob([pdf], {
          type: 'application/pdf',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        link.click();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onChangeEmpleado = async (value) => {
    if (value) {
      setLoading(true);
      const _empleado = empleados.find((e) => e.id === value);
      if (_empleado) {
        const _datosOp = formatReceivedValues(datosOperacionales.find((e) => e.empleado === value));
        const adminPlazaEmp = adminPlazas?.find((adminPlaza) => adminPlaza?.empleado_id === value);

        const puesto = adminPlazaEmp?.puesto; // ya trae descripción
        const area = adminPlazaEmp?.directorio_area?.trim(); // ya trae descripción
        const tipo_de_empleado = adminPlazaEmp?.tipo_de_empleado; // ya trae descripción

        const fecha_de_alta = _datosOp?.fecha_de_alta;
        const antiguedad = fecha_de_alta ? calcularAntiguedad(fecha_de_alta) : null;
        const dias_disfrutados = _datosOp?.dias_habiles_disfrutados;
        const dias_pendientes = _datosOp?.dias_habiles_pendientes;
        const estatus = estadosDelEmpleado.find((e) => e.id === _empleado?.estado_del_empleado)?.descripcion;

        const _vacacionesPeriodos = await getVacacionesEmpleadosPeriodos({ empleado: value });
        const _vacacionesDisfrutad = await getVacacionesEmpleadosDiasDisfrutados({ empleado: value });

        form.setFieldsValue({
          puesto,
          area,
          tipo_de_empleado,
          fecha_de_alta,
          antiguedad,
          dias_disfrutados,
          dias_pendientes,
          estatus,
        });

        setVacacionesEmpleadosPeriodos(_vacacionesPeriodos);
        setVacacionesEmpleadosDisfrutados(_vacacionesDisfrutad);
        setAllowPrint(true);
        setLoading(false);
      } else {
        const _datosOp = formatReceivedValues(datosOperacionales.find((e) => e.empleado === value));
        const adminPlazaEmp = adminPlazas?.find((adminPlaza) => adminPlaza?.empleado_id === value);

        const puesto = adminPlazaEmp?.puesto; // ya trae descripción
        const area = adminPlazaEmp?.directorio_area?.trim(); // ya trae descripción
        const tipo_de_empleado = adminPlazaEmp?.tipo_de_empleado; // ya trae descripción

        const fecha_de_alta = _datosOp?.fecha_de_alta;
        const antiguedad = fecha_de_alta ? calcularAntiguedad(fecha_de_alta) : null;
        const dias_disfrutados = _datosOp?.dias_habiles_disfrutados;
        const dias_pendientes = _datosOp?.dias_habiles_pendientes;
        const estatus = estadosDelEmpleado.find((e) => e.id === _empleado?.estado_del_empleado)?.descripcion;
        form.setFieldsValue({
          puesto,
          area,
          tipo_de_empleado,
          fecha_de_alta,
          antiguedad,
          dias_disfrutados,
          dias_pendientes,
          estatus,
        });

        notification.warning({
          message: 'Sin vacaciones registradas',
          description: 'El empleado  no cuenta con periodos de vacaciones.',
        });

        setVacacionesEmpleadosPeriodos([]);
        setVacacionesEmpleadosDisfrutados([]);
        setAllowPrint(false);
        setLoading(false);
      }
    } else {
      form.resetFields();
      setVacacionesEmpleadosPeriodos([]);
      setVacacionesEmpleadosDisfrutados([]);
      setAllowPrint(false);
    }
  };

  const validateInput = async () => {
    setLoading(true);
    setSelectedEmpleado();
    const searchEmp = form.getFieldValue('empleado');
    if (!searchEmp) {
      setVisible(true);
      return setLoading(false);
    }
    const res = await getEmpleadosConDatosOpFilteredPaginated(`${baseURI}numero_de_empleado=${searchEmp};`);
    const result = res?.results[0];
    if (!res) {
      return setLoading(false);
    }
    const empleadoResult = result?.empleado;
    setSelectedEmpleado(empleadoResult);
    form.setFieldsValue({
      empleado: `${empleadoResult?.numero_de_empleado || ''} - ${empleadoResult?.nombre || ''} ${empleadoResult?.apellido_paterno || ''} ${empleadoResult?.apellido_materno || ''}`,
    });
    onChangeEmpleado(empleadoResult?.id);
    return setLoading(false);
  };

  const searchData = async (empId, nombreEmp, apPatEmp, apMatEmp, tipoNominaEmpleado) => {
    setLoading(true);
    if (empId) {
      baseURI = `${baseURI}numero_de_empleado=${empId};`;
    }
    if (nombreEmp) {
      baseURI = `${baseURI}nombre=${nombreEmp};`;
    }
    if (apPatEmp) {
      baseURI = `${baseURI}apellido_paterno=${apPatEmp};`;
    }
    if (apMatEmp) {
      baseURI = `${baseURI}apellido_materno=${apMatEmp};`;
    }
    if (tipoNominaEmpleado) {
      baseURI = `${baseURI}&tipo_de_nomina_empleado=${tipoNominaEmpleado}&`;
    }
    setBaseURIPagination(baseURI);
    const _empleados = await getEmpleadosConDatosOpFilteredPaginated(baseURI);
    setData(formatReceivedClone(_empleados));
    return setLoading(false);
  };

  const columnsEmpleado = [
    {
      titleText: 'No. de Empleado',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 200,
      render: (empObject) => empObject?.numero_de_empleado,
    },
    {
      titleText: 'Nombre',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.nombre,
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_paterno,
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 250,
      render: (empObject) => empObject?.apellido_materno,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'empleado',
      key: 'empleado',
      width: 300,
      render: (empObject) => {
        const adminPlazaEmp = adminPlazas?.find((admP) => admP?.empleado === empObject?.id);
        const plazaEmp = plazas?.find((pl) => pl?.id === adminPlazaEmp?.plaza);
        const puestoEmp = puestos?.find((p) => p?.id === plazaEmp?.puesto);
        return `${puestoEmp?.descripcion || ''}`;
      },
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 250,
      render: (tneEmp) => tiposDeNominaEmpleado?.find((tne) => tne?.id === tneEmp)?.descripcion,
    },
  ];

  const registroVacacionesCols = [
    {
      titleText: 'Año',
      dataIndex: 'ano',
      key: 'ano',
      width: 150,
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'N/A'),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 200,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'N/A'),
    },
    {
      titleText: 'No. de Periodos',
      dataIndex: 'numero_de_periodos',
      key: 'numero_de_periodos',
      width: 200,
    },
    {
      titleText: 'Total de Días por Año',
      dataIndex: 'total_de_dias_habiles_por_ano',
      key: 'total_de_dias_habiles_por_ano',
      width: 250,
    },
    {
      titleText: '% de Prima Vacacional',
      dataIndex: 'porcentaje_prima_vacacional',
      key: 'porcentaje_prima_vacacional',
      width: 250,
      render: (val) => percentFormatter(val),
    },
    {
      titleText: 'Días Hábiles Disfrutados',
      dataIndex: 'dias_habiles_disfrutados',
      key: 'dias_habiles_disfrutados',
      width: 250,
    },
    {
      titleText: 'Días Hábiles Pendientes',
      dataIndex: 'dias_habiles_pendientes',
      key: 'dias_habiles_pendientes',
      width: 250,
    },
  ];

  const vacacionesDisfrutadasCols = [
    {
      titleText: 'Año',
      dataIndex: 'ano',
      key: 'ano',
      width: 150,
    },
    {
      titleText: 'Periodo',
      dataIndex: 'periodo_texto',
      key: 'periodo_texto',
      width: 200,
    },
    {
      titleText: 'Días con Derecho',
      dataIndex: 'dias_con_derecho',
      key: 'dias_con_derecho',
      width: 200,
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 250,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'N/A'),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 250,
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : 'N/A'),
    },
    {
      titleText: 'Días Hábiles Disfrutados',
      dataIndex: 'dias_habiles_disfrutados',
      key: 'dias_habiles_disfrutados',
      width: 250,
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 350,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          className="form-container"
          title="Consulta de Vacaciones"
          extra={(
            <FormSubmitControls
              onPrint={onPrint}
              allowPrint={allowPrint}
            />
          )}
          bordered={false}
        >
          <Form
            layout="vertical"
            name="general"
            form={form}
            scrollToFirstError
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Row align="middle">
                  <Col xs={24} sm={24} md={24}>
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Form.Item
                        label="No. y Nombre del Empleado"
                        name="empleado"
                        hasFeedback
                      >
                        <Input
                          allowClear
                        />
                      </Form.Item>
                      <Button
                        loading={loading}
                        onClick={validateInput}
                        icon={<SearchOutlined />}
                        style={{
                          width: '2.7rem',
                          marginTop: '-2px',
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
              {selectedEmpleado
                ? (
                  form.setFieldsValue({
                    empleado: `${selectedEmpleado?.numero_de_empleado || ''} - ${selectedEmpleado?.nombre || ''} ${selectedEmpleado?.apellido_paterno || ''} ${selectedEmpleado?.apellido_materno || ''}`,
                  })
                ) : null}
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="puesto"
                  label="Puesto"
                >
                  <Select
                    keyProp="id"
                    labelProp="descripcion"
                    dataSource={puestos}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="area"
                  label="Área"
                >
                  <Input
                    disabled
                    dataSource={areas}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="tipo_de_empleado"
                  label="Tipo de Empleado"
                >
                  <Select
                    keyProp="id"
                    labelProp="descripcion"
                    dataSource={tiposDeEmpleados}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="fecha_de_alta"
                  label="Fecha de Alta"
                >
                  <DatePicker
                    placeholder=""
                    format="DD/MM/YYYY"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="antiguedad"
                  label="Antigüedad"
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="dias_disfrutados"
                  label="Días Disfrutados"
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="dias_pendientes"
                  label="Días Pendientes"
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="estatus"
                  label="Estatus"
                >
                  <Select
                    keyProp="id"
                    labelProp="descripcion"
                    dataSource={estadosDelEmpleado}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Row gutter={10}>
            <Col style={{ marginBottom: '20px' }}>
              <Text style={{ color: '#D88F4F' }}>Registro de Vacaciones</Text>
              <Table
                cols={registroVacacionesCols}
                data={vacacionesEmpleadosPeriodos}
                allowExportParam={false}
                allowSearch={false}
              />
            </Col>
          </Row>
          <Row gutter={10}>
            <Col>
              <Text style={{ color: '#D88F4F' }}>Vacaciones Disfrutadas</Text>
              <Table
                cols={vacacionesDisfrutadasCols}
                data={vacacionesEmpleadosDisfrutados}
                allowExportParam={false}
                allowSearch={false}
              />
            </Col>
          </Row>
        </Card>
        <CustomSearch
          form={form}
          open={open}
          setVisible={setVisible}
          modalTitle="Buscar Empleado"
          firstInputLabel="No. de Empleado"
          firstInputName="numero_de_empleado"
          secondInputLabel="Nombre del Empleado"
          secondInputName="nombre"
          searchInputLabel="Apellido Paterno"
          searchInputName="apellido_paterno"
          thirdInputLabel="Apellido Materno"
          thirdInputName="apellido_materno"
          firstSelectLabel="Tipo de Nómina Empleado"
          firstSelectName="tipo_de_nomina_empleado"
          firstSelectDataSource={tiposDeNominaEmpleado}
          inputsNeeded={3}
          selectsNeeded={1}
          paginatedTable
          modalWidth={1400}
          columns={columnsEmpleado}
          baseURI={baseURIPagination}
          setSelectedRow={setSelectedEmpleado}
          onFinishGet={getEmpleadosConDatosOpFilteredPaginated}
          formatReceivedClone={formatReceivedClone}
          data={data}
          setData={setData}
          searchData={searchData}
          onChange={onChangeEmpleado}
        />
      </Spin>
    </Row>
  );
};

export default ConsultaVacaciones;
